export default __webpack_public_path__ + "static/media/background.a2f59386.png";